var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.172L17.585.586 19 2 7 14 .636 7.636 2.05 6.222 7 11.172z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMDAwMjMgMTEuMTcyTDE3LjU4NTIgMC41ODZMMTkuMDAwMiAyTDcuMDAwMjMgMTRMMC42MzYyMyA3LjYzNjAxTDIuMDUwMjMgNi4yMjIwMUw3LjAwMDIzIDExLjE3MloiIGZpbGw9IiMyNTI0MUQiLz4KPC9zdmc+Cg==";
export { SvgCheck as ReactComponent };